// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/logo/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-container {
  width: 100vw;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  background-size: contain;
  align-items: center;
  overflow-x: hidden;
  overflow-y: hidden;
  position: fixed;
}

.login-card {
  background: #fff;
  padding: 30px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  width: 400px;
}
.login-card h2 {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #6c757d;
}
.login-card .bold-text {
  font-weight: 600;
  color: #1a1a1a;
}
.login-card .login-button {
  width: 100%;
  padding: 12px;
  background-color: #1c77e2;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 15px 0;
  transition: 0.3s;
}
.login-card .login-button:hover {
  background-color: #3b7dd8;
}
.login-card .terms {
  font-size: 12px;
  color: #6c757d;
}
.login-card .terms a {
  color: #4a90e2;
  text-decoration: none;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Login/Login.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AACA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,YAAA;AAEJ;AAAI;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEN;AACI;EACE,gBAAA;EACA,cAAA;AACN;AAEI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAAN;AAEM;EACE,yBAAA;AAAR;AAII;EACE,eAAA;EACA,cAAA;AAFN;AAIM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAFR","sourcesContent":[".bg-container {\n    width: 100vw;\n    height: 100vh;\n    background-image: url('../../../assets/logo/bg.png'); // Use correct path\n    background-position: center;\n    background-repeat: no-repeat;\n    display: flex;\n    justify-content: center;\n    background-size: contain;\n    align-items: center;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: fixed;\n  }\n.login-card {\n    background: #fff;\n    padding: 30px;\n    text-align: center;\n    border-radius: 12px;\n    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);\n    width: 400px;\n  \n    h2 {\n      font-family: \"Inter\", sans-serif;\n      font-weight: 400;\n      font-size: 20px;\n      color: #6c757d;\n    }\n  \n    .bold-text {\n      font-weight: 600;\n      color: #1a1a1a;\n    }\n  \n    .login-button {\n      width: 100%;\n      padding: 12px;\n      background-color: #1c77e2;\n      color: white;\n      font-size: 16px;\n      font-weight: bold;\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      margin: 15px 0;\n      transition: 0.3s;\n  \n      &:hover {\n        background-color: #3b7dd8;\n      }\n    }\n  \n    .terms {\n      font-size: 12px;\n      color: #6c757d;\n  \n      a {\n        color: #4a90e2;\n        text-decoration: none;\n        font-weight: 500;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
